<template>
  <div class="riskList flex flex-direction">
    <div class="table-box flex-sub">
      <div class="total-container flex align-center justify-between">
        <div class="item-total flex align-center justify-between">
          <div class="flex align-center">
            <div class="icon iconfont icon-yonghushenhe"></div>
            <div class="label">待审核预警处理</div>
          </div>
          <div class="number"><span>{{ total.shenhe }}</span>项</div>
        </div>
        <div class="item-total green flex align-center justify-between">
          <div class="flex align-center">
            <div class="icon iconfont icon-bangong-jigou"></div>
            <div class="label">预警涉及机构数量</div>
          </div>
          <div class="number"><span>{{ total.org_num }}</span>项</div>
        </div>
        <div class="item-total blue flex align-center justify-between">
          <div class="flex align-center">
            <div class="icon iconfont icon-yujingxinxifabu"></div>
            <div class="label">预警信息共计</div>
          </div>
          <div class="number"><span>{{ total.nums }}</span>项</div>
        </div>
        <div class="item-total yellow flex align-center justify-between">
          <div class="flex align-center">
            <div class="icon iconfont icon-jiangshuiliangyujingxinxi"></div>
            <div class="label">待督办预警提示数量</div>
          </div>
          <div class="number"><span>{{ total.duban_1 }}</span>项</div>
        </div>
        <div class="item-total purple flex align-center justify-between">
          <div class="flex align-center">
            <div class="icon iconfont icon-chulizhonggongdanshuliang"></div>
            <div class="label">已督办处理中数量</div>
          </div>
          <div class="number"><span>{{ total.duban_2 }}</span>项</div>
        </div>
      </div>
      <div class="tab margin-top-sm">
                <span v-for="item in riskStatusOptions"
                      :key="item.value"
                      :class="{active:item.value == active}"
                      class="tab-item" @click="tabChange(item.value)">{{ item.label }}({{ item.count }})</span>
      </div>
      <div class="search-flex">
        <div class="search-box">
          <el-form ref="form" :model="search" class="flex" label-width="100px">
            <el-form-item label="机构名称">
              <el-input v-model="search.keyword" placeholder="请输入机构名称搜索"></el-input>
            </el-form-item>
            <el-form-item label="预警时间">
              <el-date-picker
                v-model="search.time"
                format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="级别">
              <el-select v-model="search.level" :clearable="true" class="inp" placeholder="请选择">
                <el-option
                  v-for="item in riskLevelAllOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否持证">
              <el-select v-model="search.license" :clearable="true" class="inp" placeholder="请选择">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="search-btn" @click="searchList">
            <i class="iconfont icon-sousuo"></i>搜索
          </div>
          <div class="shensu margin-left-sm" @click="addItem(false)">
            <i class="el-icon-plus"></i>添加预警信息
          </div>
          <div class="shensu margin-left-sm" @click="downLoad">
            <i class="iconfont icon-fenxiang1"></i>导出
          </div>
        </div>

      </div>
      <div class="list ">
        <el-table
          :cell-style="textCenter"
          :data="tableData"
          :header-cell-style="centerbgc"
          border
          style="width: 100%" v-loading="loading">
          <el-table-column
            label="序号"
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            label="机构名称"
            prop="org_name"
            width="">
          </el-table-column>
          <el-table-column
            label="预警状态"
            width="100">
            <template slot-scope="scope">
              <span class="level" :class="getLevelClass(scope.row.level)">{{ scope.row.level | level }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="信息"
            prop="info">
          </el-table-column>
          <el-table-column
            label="描述"
            prop="instruction">
          </el-table-column>
          <el-table-column
            label="预警时间"
            prop="update_time"
            width="180">
          </el-table-column>
          <el-table-column
            label="处理状态"
            prop="status"
            width="160">
            <template slot-scope="scope">
              <span class="level text" :class="getStatusClass(scope.row.status)">{{ scope.row.status | status }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="250">
            <template slot-scope="scope" class="flex">
              <el-link type="primary" @click="addItem(scope.row)">查看详情</el-link>
              <el-link type="warning" class="margin-left-sm" v-if="scope.row.status === 0"
                       @click="dubanItem(scope.row)">督办
              </el-link>
              <el-link type="success" class="margin-left-sm" v-if="scope.row.status === 2"
                       @click="applyItem(scope.row)">去审核
              </el-link>
              <el-link type="success" class="margin-left-sm" v-if="scope.row.status === 4"
                       @click="addItem(scope.row,false)">佐证材料
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          :current-page.sync="search.page"
          :page-size="search.limit"
          :total="search.total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>
    </div>
    <add-risk-dialog :dialog-visible="addRiskDialog" :id="cur_id" :type="cur_type"
                     @handleClose="handleClose"></add-risk-dialog>
    <duban-risk-dialog :dialog-visible="dubanRiskDialog" :id="cur_id" @handleClose="handleClose"></duban-risk-dialog>
    <apply-risk-dialog :dialog-visible="applyRiskDialog" :id="cur_id" @handleClose="handleClose"></apply-risk-dialog>
  </div>
</template>
<script>
import {isYes, riskLevelAllOptions, riskStatusOptions, riskStatusOptions2} from "@/utils/const";
import {findByType, frontDownload, resetLocationUrl} from "@/utils/utils";
import {getWarningList, getWarningListExport, getWarningStatistics} from "@/api/admin";
import AddRiskDialog from "@/views/admin/pages/risk/common/addRiskDialog";
import DubanRiskDialog from "@/views/admin/pages/risk/common/dubanRiskDialog";
import ApplyRiskDialog from "@/views/admin/pages/risk/common/applyRiskDialog";
import {fileUrl} from "@/config";

export default {
  name: "riskList",
  data() {
    return {
      fileUrl: fileUrl,
      active: 0,
      riskStatusOptions: riskStatusOptions,
      riskLevelAllOptions: riskLevelAllOptions,
      isYes: isYes,
      search: {
        keyword: '',
        time: [],
        level: '',
        license: '',
        page: 1,
        limit: 10,
        total: 0,
      },
      tableData: [],
      total: {
        all: 0, //待审核
        shenhe: 0, //待审核
        org_num: 0, //涉及机构
        nums: 0, //总数
        duban_2: 0, //已督办
        duban_1: 0, //待督办
        queren: 0 //待督办
      },
      cur_id: '',
      cur_type: false,
      applyRiskDialog: false,
      dubanRiskDialog: false,
      addRiskDialog: false,

      loading: false,
    }
  },
  components: {ApplyRiskDialog, DubanRiskDialog, AddRiskDialog},
  computed: {
    textCenter() {
      return {
        textAlign: 'center'
      }
    },
    centerbgc() {
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.search.keyword = this.$route.query.keyword
    resetLocationUrl()
    this.$emit("setActive", {
      headActive: 4
    })
    this.list()
  },
  methods: {
    async init() {
      let _data = await getWarningStatistics()
      this.total = _data.data
      this.riskStatusOptions.map(item => {
        item.count = this.total[item.key]
      })
    },
    async list() {
      this.loading = true
      this.init()
      let _data = await getWarningList(
        this.search.keyword,
        this.search.time.join(','),
        this.search.level,
        this.search.license,
        this.active,
        this.search.page,
        this.search.limit
      );
      this.loading = false
      if (_data.status == 200) {
        this.tableData = _data.data.data
        this.search.total = _data.data.total
      } else {
        this.$message.error(_data.msg)
      }
    },

    async downLoad() {
      let _data = await getWarningListExport(
        this.search.keyword,
        this.search.time.join(','),
        this.search.level,
        this.search.license,
        this.active
      );
      if (_data.status == 200) {
        let url = this.fileUrl + _data.data.path
        frontDownload(url)
      } else {
        this.$message.error(_data.msg)
      }
    },

    searchList() {
      this.search.page = 1
      this.list()
    },
    addItem(data, type = true) {
      this.cur_id = data ? data.id : ''
      this.cur_type = type
      this.addRiskDialog = true
    },
    dubanItem(data) {
      this.cur_id = data ? data.id : ''
      this.dubanRiskDialog = true
    },
    applyItem(data) {
      this.cur_id = data ? data.id : ''
      this.applyRiskDialog = true
    },
    getLevelClass(val) {
      return findByType(riskLevelAllOptions, val, {key: 'value', value: 'type'})
    },
    getStatusClass(val) {
      return findByType(riskStatusOptions2, val, {key: 'value', value: 'type'})
    },
    handleClose(e) {
      if (e) this.list()
      this.addRiskDialog = false
      this.dubanRiskDialog = false
      this.applyRiskDialog = false
    },
    tabChange(val) {
      this.active = val
      this.searchList()
    }
  },
  watch: {},
  filters: {
    level(val) {
      let label = findByType(riskLevelAllOptions, val);
      return label.substring(label.length - 2)
    },
    status(val) {
      return findByType(riskStatusOptions2, val)
    }
  }
}
</script>

<style lang="scss" scoped>
.level {
  background-color: #f2f2f2;
  border-radius: 4px;
  font-size: 14px;
  line-height: 26px;
  text-align: center;
  color: #8a8a8a;
  width: 60px;
  height: 26px;
  display: inline-block;

  &.text {
    width: unset !important;
    height: unset !important;
    background: none !important;
  }

  &.green {
    background-color: #d9f7be;
    color: #0e7701;
  }

  &.red {
    background-color: #ffdddd;
    color: #f8001a;
  }

  &.yellow {
    background-color: #fffbdd;
    color: #fad471;
  }

  &.orange {
    background-color: #ffeddd;
    color: #f58739;
  }
}

.riskList {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;

  .table-box {
    width: 100%;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    padding: 30px 20px 0;
    border-radius: 10px;
    min-height: 100%;

    .tab {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: solid 2px #e3e7f0;

      span {
        width: max-content;
        margin-left: 45px;
        height: 60px;
        line-height: 60px;
        font-size: 18px;
        color: #63686e;
        margin-right: 20px;
        cursor: pointer;

        &.active {
          color: #2791ff;
          font-weight: bold;
          border-radius: 2px;
          border-bottom: solid 4px #2791ff;
        }
      }
    }


    .list {
      width: 100%;

      .btn {
        width: 60px;
        height: 26px;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 26px;
        margin: 0 auto;

        &.gray {
          color: #8a8a8a;
          background-color: #f2f2f2;
        }

        &.yellow {
          color: #fad471;
          background-color: #fffbdd;
        }

        &.orange {
          color: #f58739;
          background-color: #ffeedd;
        }

        &.red {
          color: #f8001a;
          background-color: #ffdddd;
        }
      }
    }

    .search-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 20px 0;

      .shensu {
        min-width: 113px;
        height: 37px;
        background-image: linear-gradient(0deg,
          #f59a23 0%,
          #feb555 100%);
        border-radius: 4px;
        padding: 0 20px;
        text-align: center;
        line-height: 37px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;

        i {
          font-size: 20px;
          margin-right: 5px;
          color: #ffffff;
        }
      }

      .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .search-btn {
          width: 112px;
          height: 36px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 15px;
          cursor: pointer;

          i {
            font-size: 20px;
            margin-right: 5px;
            color: #ffffff;
          }

          &.reset {
            background-image: none;
            background-color: #ffffff;
            border-radius: 4px;
            border: solid 1px #cccccc;
            line-height: 34px;
            color: #333333;

            i {
              color: #999999;
            }
          }
        }
      }

    }
  }


  .total-container {
    .item-total {
      width: 347px;
      height: 95px;
      background-image: linear-gradient(269deg,
        #ffa18c 0%,
        #ff6a51 100%);
      border-radius: 10px;
      padding: 0 25px;

      &.green {
        background-image: linear-gradient(269deg,
          #54d278 0%,
          #3ec695 100%);
      }

      &.blue {
        background-image: linear-gradient(269deg,
          #6ad3ff 0%,
          #1da9ff 100%);
      }

      &.yellow {
        background-image: linear-gradient(269deg,
          #ffb76a 0%,
          #ff8d13 100%);
      }

      &.purple {
        background-image: linear-gradient(269deg,
          #c28cff 0%,
          #9b51ff 100%);
      }

      .icon {
        width: 51px;
        height: 51px;
        line-height: 51px;
        background-color: #ffffff22;
        border-radius: 26px;
        color: #ffffff;
        font-size: 26px;
        text-align: center;
      }

      .label {
        font-size: 16px;
        line-height: 30px;
        color: #ffffff;
        margin-left: 20px;
      }

      .number {
        font-size: 16px;
        color: #ffffff;

        span {
          font-size: 33px;
          font-weight: 600;
        }
      }
    }
  }

}
</style>


